import { useMemo, useSyncExternalStore } from 'react';
import {
  createInspectSessionProjection,
  type InspectSessionProjection,
  type InspectHostSession,
} from './inspect-session.mjs';

/** Root creates a stable facade for the admitted INS controller/document. */
export function useInspectSessionProjection(
  projection: InspectSessionProjection,
): InspectHostSession {
  const snapshot = useSyncExternalStore(
    projection.subscribe,
    projection.getSnapshot,
    projection.getSnapshot,
  );
  return useMemo(() => ({ ...snapshot, ...projection.actions }), [snapshot, projection]);
}

export { createInspectSessionProjection };
export type {
  InspectHostSession,
  InspectSessionProjection,
  InspectSessionProjectionOptions,
} from './inspect-session.mjs';
